import Checkbox from '../../audi-ui-components/Checkbox';
import Button from '../../audi-ui-components/Button';
import IconFuelStation from '../../audi-ui-components/icons/FuelStation';
import IconChargingStation from '../../audi-ui-components/icons/ChargingStation';
import classnames from 'classnames';
import _pull from 'lodash/pull';
import { DEFAULT_THEME } from '../../constants';

const engineTypes = {
  "G": {label: "Petrol", icon: <IconFuelStation small />},
  "D": {label: "Diesel", icon: <IconFuelStation small />},
  "E": {label: "Electric", icon: <IconChargingStation small />},
  "H": {label: "Hybrid", icon: <IconFuelStation small />},
  "EH": {label: "Plug-in hybrid", icon: <span><IconFuelStation small /><IconChargingStation small /></span>},
};

const SelectedVariants = ({theme = DEFAULT_THEME, ...props}) => {
  
  const handleChange = (v, pull) => {
    // console.log("handleChange", v);
    if (!props.isLocked) {
      let newValue = [...props.value] || [];
      if (pull) {
        _pull(newValue, v);
      } else {
        newValue.push(v);
      }
      props.onChange(newValue);
    }
  }
  
  return (
    <div className={classnames("ryi-variants form-field", {"selected": props.selected && !props.isLocked, "locked": props.isLocked})}>
      {props.selected && !props.isLocked && <p className="aui-font-extended mb-2"><b>Models selected</b></p>}
      <div className="row">
        {props.options && props.options.map((opt, i) => {
          if (opt.ryiStatus === "SOP" && !props.isLocked) { return null; }
          let isSelected = props.value && props.value.indexOf(opt.variantId) > -1;
          let _style = {backgroundImage: `url(${opt.heroImage})`};
          if (opt.heroImageFocalPoint?.x && opt.heroImageFocalPoint?.y) {
            _style.backgroundPosition = `${opt.heroImageFocalPoint.x} ${opt.heroImageFocalPoint.y}`;
          }
          if (props.selected && !isSelected) {
            return null;
          }
          return (
            <div className={classnames("col-12 mb-4", {"col-small-6": !props.selected, "d-none d-medium-block": props.isLocked})} key={`${opt.variantId}-${i}`}>
              <div className={classnames(
                "variant",
                {
                  "aui-color-gray10 aui-color-text-light": (theme === "light" && isSelected) || (theme === "dark" && !isSelected),
                  "aui-color-gray90 aui-color-text-dark": (theme === "light" && !isSelected) || (theme === "dark" && isSelected)
                }
              )}>
                <div className="variant--image" style={_style} onClick={() => { handleChange(opt.variantId, isSelected); }} />
                {!props.isLocked && <div className="variant--checkbox">
                  <Checkbox
                    name="modelVariants"
                    value={opt.variantId}
                    label="select this model"
                    checked={isSelected}
                    onChange={() => { handleChange(opt.variantId, isSelected); }}
                  />
                </div>}
                <div className="variant--detail">
                  <p className="variant--name aui-headline-4 mb-2">{opt.name}</p>
                  <p className={classnames("variant--stats", {"d-none d-xsmall-block d-small-none d-large-block": props.selected})}>
                    {engineTypes[opt.engineType].icon} {engineTypes[opt.engineType].label}
                  </p>
                  <hr />
                  {!props.selected && 
                    <Button
                      variant="text"
                      theme={((theme === "light" && isSelected) || (theme === "dark" && !isSelected)) ? "light" : null}
                      isStretched
                      href={opt.ryiExploreLink ? opt.ryiExploreLink : opt.url ? `https://www.audi.com.au${opt.url}` : ""}
                      disabled={!opt.url && !opt.ryiExploreLink}
                      target="_blank" rel="noreferrer">View model page</Button>
                  }
                  {!props.selected && isSelected &&
                    <Button variant="primary" theme={theme === "dark" ? "light" : null} isStretched onClick={() => { handleChange(opt.variantId, isSelected); }}>
                      Selected
                    </Button>
                  }
                  {!props.selected && !isSelected &&
                    <Button variant="primary" theme={theme === "dark" ? "light" : null} isStretched onClick={() => { handleChange(opt.variantId, isSelected); }}>
                      Select this model
                    </Button>
                  }
                  {props.selected && !props.isLocked &&
                    <button className="variant--remove" onClick={() => { handleChange(opt.variantId, isSelected); }}>
                      Remove
                    </button>
                  }
                  {props.selected && props.isLocked &&
                    <div className="cms-content py-3" dangerouslySetInnerHTML={{__html: opt.ryiDescription}}></div>
                  }
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SelectedVariants;
